import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/reglages` has no content of its own — the rail's first tab is the page. */
export const Route = createFileRoute("/_dashboard/reglages/")({
  beforeLoad: () => {
    // `replace` keeps /reglages out of the history stack, so Back from the
    // first tab returns where the user came from instead of bouncing through
    // the redirect.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/reglages/general", replace: true });
  },
});
